import React from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { COLOR_PALETTE } from 'constants/ui';

import {
  DEFAULT_COLOR_MATCH,
  LabelBorderStyle,
  LabelSize,
  LabelVariant,
  TypographyVariant,
} from './LabelCDS.constants';
import { getLabelStyles } from './LabelCDS.styles';

const LabelCDS = ({
  variant = LabelVariant.GREEN,
  title = 'Done',
  size = LabelSize.L,
  colorMatch = DEFAULT_COLOR_MATCH,
  withBorder = false,
  borderStyle = LabelBorderStyle.SOLID,
  shrinkable = false,
  dataTestId,
}) => {
  return (
    <Typography
      className="px-8"
      data-testid={dataTestId}
      sx={getLabelStyles({ variant, colorMatch, withBorder, borderStyle, shrinkable })}
      variant={TypographyVariant[size]}
    >
      {title}
    </Typography>
  );
};

const colorNumbers = Array.from(
  { length: COLOR_PALETTE.BRAND.length - 1 },
  (_, index) => index + 1,
);

LabelCDS.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  variant: PropTypes.string,
  size: PropTypes.string,
  withBorder: PropTypes.bool,
  borderStyle: PropTypes.oneOf(Object.values(LabelBorderStyle)),
  shrinkable: PropTypes.bool,
  dataTestId: PropTypes.string,
  colorMatch: PropTypes.shape({
    backgroundColor: PropTypes.oneOf(colorNumbers),
    color: PropTypes.oneOf(colorNumbers),
    borderColor: PropTypes.oneOf(colorNumbers),
  }),
};

export default LabelCDS;
